import InternalContainer from "../../../../components/units/Management/Device/internal/internalContainer";

export default function DeviceListPage() {
  return <InternalContainer />;
}
